import {combineReducers} from "redux"
import coreReducer from "../../core/reducers/core.reducer"
import refDbReducer from "../../metstat/redux/refdb.reducer"
import commonReducer from "../../common/redux/common.reducer"
import getSettingsReducer from "../../@biocrates-common-repo/settings/reducers/settings.reducer"
import {initialState, State} from "../../settings/redux/reducers/settings.state"

const rootReducer = combineReducers({
    settings: getSettingsReducer<State>(initialState),
    common: commonReducer,
    core: coreReducer,
    refDb: refDbReducer,
})

export type AppState = ReturnType<typeof rootReducer>

export default rootReducer
